/*eslint-disable multiline-ternary */
import React from 'react';
//import {languageOptions} from '../../data/constants';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';

export const LanguageFilter = ({
  value,
  onChange,
  data: languagesList,
  ...otherProps
}) => {
  const selectedValue = value
    ? value.map((val) => {
        return { label: val, value: val };
      })
    : null;
  const languageOptions = languagesList || [];

  return (
    <AutoSuggestionSelectComponent
      placeholder="Languages Spoken"
      options={languageOptions}
      //inputClassName="provider-language-filter"
      isMulti
      components={{ IndicatorSeparator: () => null }}
      value={selectedValue}
      onChange={onChange}
      {...otherProps}
      inputClassName="best-match-filter height-32"
    />
  );
};
